"use strict";

function toBoolean(value) {
  return !!value;
}

module.exports = toBoolean;
